import type { AdminFlowNode } from "../models/admin-flows.models";

export const ADMIN_FLOW_CARD_WIDTH = 184;
export const ADMIN_FLOW_CARD_HEIGHT = 104;
export const ADMIN_FLOW_CANVAS_MIN_WIDTH = 1000;
export const ADMIN_FLOW_CANVAS_MIN_HEIGHT = 600;
export const ADMIN_FLOW_TOOLS_PER_NODE = 8;

export const ADMIN_FLOW_SOURCE_OPTIONS = [
  { value: "vessels", label: "Vessel search", description: "Deterministic vessel criteria" },
  { value: "documents", label: "Document search", description: "Vessel document criteria" },
  { value: "support", label: "Support inbox", description: "Approved support mailbox" },
  { value: "offline_tech_form", label: "Tech Form inbox", description: "Approved offline form mailbox" },
];

export const ADMIN_FLOW_STEP_OPTIONS: Array<{ kind: AdminFlowNode["kind"]; label: string; description: string }> = [
  { kind: "agent", label: "AI tool", description: "Select a tool and instructions" },
  { kind: "merge", label: "Merge inputs", description: "Wait for every connected input" },
];

export const ADMIN_FLOW_OUTPUT_OPTIONS: Array<{ kind: AdminFlowNode["kind"]; label: string; description: string }> = [
  { kind: "text", label: "Text output", description: "Prepare the final response" },
  { kind: "email", label: "Email output", description: "Prepare an email for review" },
];

export const ADMIN_FLOW_TOOL_GROUPS = ["Business", "Admin", "Developer Diagnostics", "OGA"];

export const ADMIN_FLOW_SOURCE_ARGUMENT_HELP: Record<string, string> = {
  vessels:
    "Start with operation: read, view: fleet_filters and limit: 10. Add the permitted vessel filters needed for this flow.",
  documents:
    "Enter vesselCode and imo for the actual vessel whose documents should be read. Vessel identifiers are required; the draft never invents them.",
  support:
    "pageSize controls the bounded message page. The backend fixes mailboxId to the approved support mailbox; this source cannot read another inbox.",
  offline_tech_form:
    "pageSize controls the bounded message page. The backend fixes mailboxId to the approved offline Tech Form mailbox; this source cannot read another inbox.",
};

export const ADMIN_FLOW_KIND_LABELS: Record<AdminFlowNode["kind"], string> = {
  source: "Data source",
  agent: "AI step",
  merge: "Merge inputs",
  text: "Text output",
  email: "Email output",
};

export const ADMIN_FLOW_KIND_COLORS: Record<AdminFlowNode["kind"], string> = {
  source: "border-l-green",
  agent: "border-l-purple-400",
  merge: "border-l-blue-400",
  text: "border-l-amber-400",
  email: "border-l-amber-400",
};

export const ADMIN_FLOW_FIELD_CLASS =
  "mt-1 w-full select-text rounded border border-gray-300 bg-white px-3 py-2 text-sm outline-none focus:border-green focus:ring-1 focus:ring-green dark:border-gray-600 dark:bg-gray-800";

export const ADMIN_FLOW_SECONDARY_BUTTON_CLASS =
  "rounded border border-gray-300 px-3 py-2 text-xs font-semibold hover:bg-greyscale-10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-green disabled:opacity-40 dark:border-gray-600 dark:hover:bg-gray-700";
